module.exports = __webpack_public_path__ + "img/redflag.63b3e844.svg";